import React, { Fragment } from "react";
import { Footerdark, PageLayout } from "../../../Constant";
import PackagesForm from "./PackagesForm";

const PackagesAdd = () => {
    return (
        <Fragment>
            <PackagesForm mainTitle={Footerdark} title={Footerdark} parent={PageLayout} />         
        </Fragment>
    )
}
export default PackagesAdd;